import { loginByUsername1, logout, addCarByString } from '@/api/login'
import { getToken, setToken, removeToken, setUserId, getUserId, removeUserId, getBuy, removeBuy } from '@/utils/auth'
import store from '..'

const user = {
  state: {
    user: '',
    status: '',
    token: getToken(),
    firstName: '',
    lastName: '',
    userid: getUserId(),
    avatar: '',
    remark: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_REMARK: (state, remark) => {
      state.remark = remark
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_FIRST_NAME: (state, firstName) => {
      state.firstNameme = firstName
    },
    SET_LAST_NAME: (state, lastName) => {
      state.lastName = lastName
    },
    SET_USERID: (state, userid) => {
      state.userid = userid
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const email = userInfo.email.trim()
      let p = new Promise((resolve, reject) => {
        loginByUsername1(email, userInfo.password, userInfo.isRead).then(response => {
          const token = response.data.data.token
          const userid = response.data.data.id
          console.log(response.data.data)
          commit('SET_TOKEN', token)
          commit('SET_USERID',userid)
          setToken(token)
          setUserId(userid)

          //检查本地存储是否有购物车信息
          var gids = getBuy()
          console.log('缓存来了')
          console.log(gids)
          if(gids){
            let postData={
              userId: userid,
              gId: gids
            }
            console.log(postData)
            addCarByString(postData).then(rr=>{
              console.log('存储购物车开始')
              removeBuy()
            }).catch(erro=>{
              console.log(erro)
            })
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
      // console.log(p)
      return p;
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      // return new Promise((resolve, reject) => {
      //   getUserInfo(state.token).then(response => {
      //     const data = response.data.data
      //     if ( data.userid > 0) { // 验证返回的perms是否是一个非空数组
      //       console.log(data)
      //       commit('SET_USERID', data.userid)
      //       commit('SET_FIRST_NAME', data.firstName)
      //       commit('SET_LAST_NAME', data.lastName)
      //       commit('SET_AVATAR', data.avatar)
      //       commit('SET_REMARK', data.remark)
      //       commit('SET_GOOGLE_VERIFIER_KEY', data.qrCode)
      //     } else {
      //       reject('getInfo: perms must be a non-null array !')
      //     }

      //     resolve(response)
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },

    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.userid).then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          commit('SET_USERID', '')
          removeUserId()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        commit('SET_USERID', '')
        removeUserId()
        resolve()
      })
    },

    // 三方登录，信息保存
    LoginByThirdParty({ commit }, userInfo) {
      console.log('三方登录userInfo:', userInfo)
      commit('SET_TOKEN', userInfo.token)
      setToken(userInfo.token)
      commit('SET_USERID', userInfo.userId)
      setUserId(userInfo.userId)
      //检查本地存储是否有购物车信息
      var gids = getBuy()
      console.log('三方缓存来了')
      console.log(gids)
      if(gids){
        let postData={
          userId: userid,
          gId: gids
        }
        console.log(postData)
        addCarByString(postData).then(rr=>{
          console.log('三方存储购物车开始')
          removeBuy()
        }).catch(erro=>{
          console.log(erro)
        })
      }
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js